export function headingUpdate() {
    document.querySelectorAll('.text-field').forEach(container => {
        container.querySelectorAll('h2').forEach(h2 => {
            h2.classList.add('heading', 'heading--m');
        });
        container.querySelectorAll('h3').forEach(h3 => {
            h3.classList.add('heading', 'heading--s');
        });
    });
}